import { siteCart as enSiteCart } from '../en-us/siteCart';

export const siteCart = {
  ...enSiteCart,
  title: 'Dein Warenkorb',
  emptyState: {
    label: 'Ihr Warenkorb ist leer.',
    subtitle:
      'Fügen Sie einige Produkte hinzu und machen Sie sich bereit, die Verantwortung für Ihre Gesundheit zu übernehmen!',
    buttonLabel: 'Produkte kaufen'
  },
  subscriptionTitle: 'Abonnementkäufe',
  oneTimeTitle: 'Einmalkäufe',
  freeGiftsTitle: 'Kostenlose Geschenke',
  free: 'Kostenlos',
  clearCartText: 'Alles löschen',
  upsellTitle: 'Das könnte dir auch gefallen',
  subtotalLabel: 'Zwischensumme',
  checkoutLabel: 'Zur Kasse'
};
